<template>
    <vue-final-modal
        name="menu-modal"
        class="modal-common full-modal"
        @before-open="handlerBeforeOpen"
        @before-close="handlerBeforeClose"
        v-model="setModal"
    >

        <div class="container-full-modal" v-if="setModal">
            <div class="fs-0">
                <div class="modal-header">
                    <div class="btn-close" @click="$vfm.hide('menu-modal')"></div>
                </div>

            </div>

            <div class="container-scroll pt4 pr16 pl16 pb50">
                <div class="box-menu-header">
                    <div class="box-flex a-start mb20">
                        <div class="mr-auto b19600">{{ UserInfo.mbName }}님, 반가워요</div>
                        <div class="box-flex gap4 fs-0 mt4">
                            <!-- <div class="img-point"></div>
                            <div
                                class="b15500"
                                v-if="!isLoading"
                            >{{ commaAdd(pointBalanceData.memberPoint) }} 포인트
                            </div> -->
                        </div>
                    </div>
                    <div class="box-flex j-end">
                        <div class="box-flex gap4" @click="userLogout()">
                            <div class="g813500">로그아웃</div>
                            <div class="icon-arrow-gray"></div>
                        </div>
                    </div>
                </div>
<!--                <div class="box-menu">-->
<!--                    <div class="title-menu">포인트&코인존</div>-->
<!--                    <div class="btn-menu" @click="pageMove('/mission')">이벤트</div>-->
<!--                    <div class="btn-menu" @click="pageMove('/coin')">코인몰</div>-->
<!--                </div>-->
                <div class="box-menu">
                    <div class="title-menu">선물함</div>
                    <!-- <div class="btn-menu" @click="pageMove('/coin')">코인몰</div> -->
                    <div class="btn-menu" @click="pageMove('/ttoba')">또바몰</div>
                    <div class="btn-menu" @click="pageMove('/event')">이벤트</div>
                </div>
                <div v-if="showLiveSubscriptionMenu" class="box-menu">
                    <div class="title-menu">라이브 구독</div>
                    <div class="btn-menu" @click="pageMove('/live')">라이브 구독</div>
                </div>
                <div class="box-menu">
                    <div class="title-menu">이웃 파트너 정보</div>
                    <div class="btn-menu" @click="moveParterPage()">이웃 파트너 정보</div>
                    <div class="btn-menu" @click="pageMove('/mypage/video')">영상 콘텐츠 관리</div>
                    <!--                    <div class="btn-menu"  @click="pageMove('/shopping')">쇼핑 콘텐츠 관리</div>-->
                    <div class="btn-menu" @click="pageMove('/ad')">광고 콘텐츠 관리</div>

                </div>
                <div class="box-menu">
                    <div class="title-menu">마이페이지</div>
                    <div class="btn-menu" @click="pageMove('/mypage')">마이페이지</div>
                </div>
                <div class="box-menu">
                    <div class="title-menu">고객센터</div>
                    <!--                    @click="$router.push('/service')"-->
                    <div class="btn-menu" @click="pageMove('/mypage/notice')">공지사항</div>
                    <div class="btn-menu" @click="pageMove('/mypage/terms')">약관</div>
                    <div class="btn-menu" @click="pageMove('/mypage/faq')">자주 묻는 질문</div>
                    <div class="btn-menu" @click="pageMove('/mypage/qna')">1:1 문의</div>
                </div>


            </div>
        </div>

    </vue-final-modal>
</template>
<script>
import util from "@/mixins/util";
import {logout} from "@/mixins/Auth.js";
import {mapState} from "vuex";
import alertMixins from "@/mixins/alertMixins.js";
import AuthMixins from "@/mixins/AuthMixins";

export default {
    name: "MenuModal",
    mixins: [alertMixins, AuthMixins],
    components: {},
    props: {},
    data() {
        return {
            setModal: false,
            pointBalanceData: {},
            isLoading: true,
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: (state) => state.userInfo.UserInfo,
            liveChannelDisplay: state => state.common.liveChannelDisplay.WEB.list,
        }),
      showLiveSubscriptionMenu() {
        if (!Array.isArray(this.liveChannelDisplay) || this.liveChannelDisplay.length === 0) {
          return true;
        }

        return !this.liveChannelDisplay.every(channel => Number(channel.lcdiDisplay) === 0);
      },
    },
    methods: {
        pageMove(data) {
            if (data === "/mypage/video" && !this.isMediaPartner()) {
                this.createConfirm({
                    title: "이웃 파트너 가입 안내",
                    content:
                        "해당 콘텐츠 이웃 파트너 회원이 아닙니다.<br>이웃 파트너 회원으로 가입 후 이용해 주세요.",
                    confirmText: "가입하기",
                    confirm: () => {
                        this.$router.push("/mypage/partner");
                        this.$vfm.hide("menu-modal");
                    },
                });
                // return;
            } else if (data === "/ad" && !this.isAdPartner()) {
                this.createConfirm({
                    title: "이웃 파트너 가입 안내",
                    content:
                        "해당 콘텐츠 이웃 파트너 회원이 아닙니다.<br>이웃 파트너 회원으로 가입 후 이용해 주세요.",
                    confirmText: "가입하기",
                    confirm: () => {
                        this.$router.push("/mypage/partner");
                        this.$vfm.hide("menu-modal");
                    },
                });
            } else if (data === "/shopping" && !this.isPartnerType('SHOPPING')) {
                this.createConfirm({
                    title: "이웃 파트너 가입 안내",
                    content:
                        "해당 콘텐츠 이웃 파트너 회원이 아닙니다.<br>이웃 파트너 회원으로 가입 후 이용해 주세요.",
                    confirmText: "가입하기",
                    confirm: () => {
                        this.$router.push("/mypage/partner");
                        this.$vfm.hide("menu-modal");
                    },
                });
            } else {
                this.$router.push(data);
                this.$vfm.hide("menu-modal");
            }
        },

        handlerBeforeOpen() {
            document.querySelector("html").style.overflow = "hidden";

            this.setModal = true;
            this.getMemberPointBalance();
        },
        handlerBeforeClose() {
            document.querySelector("html").style.overflow = "auto";
            this.setModal = false;
        },

        userLogout() {
            this.createConfirm({
                title: "로그아웃",
                content: "로그아웃 하시겠습니까?",
                confirm: () => {
                    logout();
                    this.$vfm.hide("menu-modal");
                },
            });
        },
        moveParterPage() {
            // if (
            //     this.UserInfo.PartnerType &&
            //     this.UserInfo.PartnerType.length > 0
            // ) {
            //     this.pageMove("/mypage/partner/Info");
            // } else {
            // }
            this.pageMove("/mypage/partner");
        },
        async getMemberPointBalance() {
            try {
                const response = await this.$api.$member.getMemberPointBalance({});
                if (response.success && response.result && response.result.data) {
                    this.isLoading = false;
                    this.pointBalanceData = response.result.data;
                }
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        commaAdd(data) {
            if (!util.isEmpty(data)) {
                data = data * 1;
                return data.toLocaleString();
            } else {
                return data;
            }
        },
    },
    watch: {},
};
</script>

<style scoped></style>
